import { cn } from '@utils/cn';
import React from 'react';

interface ChargedToInvoiceBadgeProps {
  invoiceNumber?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
}

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs h-5',
  md: 'px-3 py-1 text-sm h-6',
  lg: 'px-4 py-1.5 text-base h-8',
};

export const ChargedToInvoiceBadge: React.FC<ChargedToInvoiceBadgeProps> = ({
  invoiceNumber,
  size = 'sm',
  className = '',
  onClick,
}) => {
  const baseClasses =
    'inline-flex items-center justify-center gap-1.5 rounded-full font-medium whitespace-nowrap w-fit bg-indigo-100 text-indigo-800';
  const cursorClass = onClick ? 'cursor-pointer hover:bg-indigo-200' : '';
  const label = invoiceNumber ? `Charged to ${invoiceNumber}` : 'Charged to invoice';

  return (
    <span
      className={cn(baseClasses, sizeClasses[size], cursorClass, className)}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}>
      <span className="w-2 h-2 rounded-full bg-indigo-500" />
      {label}
    </span>
  );
};
